// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1VM8g","inner":"Form_inner__3nB5G","range":"Form_range__1cwmN","name":"Form_name__qL-Vm","actions":"Form_actions__2zwU6"};